export default __webpack_public_path__ + "static/Content-e6bbb23e8ad38ca579c916f32512de6b.mp4";